module.exports = __webpack_public_path__ + "img/tour-1.905c7f93.svg";